import { isEmptyObject, isEmptyArray } from '@sky-it-livedata-libraries/livedata-commons';
import { TeamDriverPageQuery } from '../types';

/**
 * typeguard for SeasonRankingGalleryQuery
 * @param TeamDriverPageQuery object passed to transformer
 */
export const isValidTeamDriverPage = (obj: TeamDriverPageQuery): boolean => Boolean(obj?.data?.getTeamDriverPageWidget && !isEmptyObject(obj.data.getTeamDriverPageWidget) );
